{
  "version": 1,
  "asset_id": "7f1bbba3-f31d-4785-9020-75649d1d78d7",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/7f1bbba3-f31d-4785-9020-75649d1d78d7/austin-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/7f1bbba3-f31d-4785-9020-75649d1d78d7/austin-640.avif",
  "original_filename": "austin-640.avif",
  "size": 19106,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:25:45Z"
}
